import { useState } from 'react';
import Mainmenu from './Mainmenu';
import Products from './Products';
import you from '../images/boy.png';
import bot from '../images/happy.png';

const Lastmenu = ({data1}) => {
    
    const num=data1;
    const [time] =useState(new Date());

    const [showFrame1, setShowFrame1] = useState(false);

    const handleShowFrame1 = () => {
      setShowFrame1(true);
    };
                  const [showFrame2, setShowFrame2] = useState(false);
                
                  const handleShowFrame2 = () => {
                    setShowFrame2(true);
                    
                  };
      
                  const [showFrame3, setShowFrame3] = useState(false);
                
                  const handleShowFrame3 = () => {
                    setShowFrame3(true);
                  };
    return(
        <>
            <div className="frame1 animated-frame">
                {/* <img src={image} className="IMAGE" alt="img" /> */}
                <div className='box1'>  
                How can I help you now?<br></br>
                <div style={{textAlign: 'center'}}>
                    <button className='menu-btn' onClick={handleShowFrame1}>Previous Menu</button>
                    <button className='menu-btn' onClick={handleShowFrame2}>Main Menu</button>
                    <button className='menu-btn' onClick={handleShowFrame3}>Exit</button>
                    </div>
                    </div>
            </div>
        {showFrame1 && (
            <>

            
            <Products />
            </>
            )}
        {showFrame2 && (
            <>
            <div className="you-time animated-frame">
              <img src={you} alt="boy" className="boy" />
              You {time?.toLocaleTimeString()}</div>
            <div className="you-message">
              <div className="frame2 animated-frame"><b>Main Menu</b></div>
            </div>

            
            <Mainmenu />
            </>
        )}
        {showFrame3 && (
            <>
             <div className="you-time animated-frame">
              <img src={you} alt="boy" className="boy" />
              You {time?.toLocaleTimeString()}</div>
            <div className="you-message ">
              <div className="frame2 animated-frame"><b>Exit</b></div>
            </div>
            <div className='chatbot'>
              <img src={bot} alt="bot" className="bot" />
              <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className='frame1 animated-frame' >
                {/* <img src={image} alt='img' className='IMAGE'></img> */}
                <div className='box1'>
                    Thank You! for Visiting Us.
                </div>
               
            </div>
            </>
        )}
            

        </>
    );
}
export default Lastmenu;